import { Platform } from "react-native";
import { useGlobalSearchParams, useLocalSearchParams } from "expo-router";
import { Feather } from "@expo/vector-icons";
import { SFSymbol } from "sf-symbols-typescript";

export const blurhash =
  "|rF?hV%2WCj[ayj[a|j[az_NaeWBj@ayfRayfQfQM{M|azj[azf6fQfQfQIpWXofj[ayj[j[fQayWCoeoeaya}j[ayfQa{oLj?j[WVj[ayayj[fQoff7azayj[ayj[j[ayofayayayj[fQj[ayayj[ayfjj[j[ayjuayj[";

export const isWeb = Platform.OS === "web";
export const isIOS = Platform.OS === "ios";
export const isLocalhost =
  isWeb && window.location.hostname.startsWith("localhost");

export function isWebDesktop() {
  return isWeb && window.matchMedia("(min-width: 720px)").matches;
}

export const useHackyParams = isWeb
  ? useGlobalSearchParams
  : useLocalSearchParams;

export const icons = {
  tag: {
    web: "hash",
    ios: "number",
  },
  collection: {
    web: "folder-plus",
    ios: "folder",
  },
  create: {
    web: "plus",
    ios: "plus",
  },
  edit: {
    web: "edit",
    ios: "pencil",
  },
  delete: {
    web: "trash-2",
    ios: "trash",
  },
  backlog: {
    web: "inbox",
    ios: "clock",
  },
  link: {
    web: "link",
    ios: "link",
  },
  file: {
    web: "file",
    ios: "doc",
  },
  media: {
    web: "image",
    ios: "photo",
  },
  note: {
    web: "file-text",
    ios: "doc.text",
  },

  workspace: {
    web: "grid",
    ios: "grid",
  },
  notification: {
    web: "bell",
    ios: "bell",
  },
  copy: {
    web: "copy",
    ios: "square.on.square",
  },
  select: {
    web: "mouse-pointer",
    ios: "cursorarrow.and.square.on.square.dashed",
  },
  team: {
    web: "users",
    ios: "person.2",
  },
  more: {
    web: "more-horizontal",
    ios: "ellipsis",
  },
} satisfies Record<
  string,
  {
    ios: SFSymbol;
    web: React.ComponentProps<typeof Feather>["name"];
  }
>;

export const reservedAccountNames = [
  "home",
  "features",
  "products",
  "pricing",
  "legal",
  "changelog",
  "contact",
  "about",
  "blog",
  "help",
  "support",
  "guides",
];

export const reserverdSpaceNames = [
  "settings",
  "billing",
  "account",
  "invite",
  "members",
  "inbox",
  "feed",
  "notifications",
];
